import { PermissionService } from '@abp/ng.core';
import { inject, Injectable } from '@angular/core';
import { IEntityPermissions } from '../models/entity-permissions-config';

@Injectable({
  providedIn: 'root',
})
export class EntityPermissions {
  private service = inject(PermissionService);
  private entityPermissions: IEntityPermissions;
  private userPermissions = new Map<string, boolean>();

  loadPermissions(permissionDefault: string) {
    this.entityPermissions = this.createPermissionsObject(permissionDefault);
    const permissionList = Object.values(this.entityPermissions);

    for (const permission of permissionList) {
      const granted = this.service.getGrantedPolicy(permission);
      this.userPermissions.set(permission, granted);
    }
  }

  get canCreate(): boolean {
    return this.hasPermission(this.entityPermissions.create);
  }

  get canEdit(): boolean {
    return this.hasPermission(this.entityPermissions.edit);
  }

  get canEditInline(): boolean {
    return this.hasPermission(this.entityPermissions.edit);
  }

  get canDelete(): boolean {
    return this.hasPermission(this.entityPermissions.delete);
  }

  get canView(): boolean {
    return this.hasPermission(this.entityPermissions.default);
  }

  private hasPermission(permission?: string): boolean {
    if (!permission) return false;

    return this.userPermissions.get(permission) || false;
  }

  get view(): string {
    return this.entityPermissions.default
  }

  get create(): string {
    return this.entityPermissions.create
  }
  get edit(): string {
    return this.entityPermissions.edit
  }
  get delete(): string {
    return this.entityPermissions.delete
  }

  private createPermissionsObject(
    permissionDefault: string
  ): IEntityPermissions {
    return {
      default: `${permissionDefault}`,
      create: `${permissionDefault}.Create`,
      delete: `${permissionDefault}.Delete`,
      edit: `${permissionDefault}.Edit`,
    };
  }
}
